// import { jsPDF } from "jspdf";
if ($('body.single-ressources-analyses, body.single-prospective').length) {

    $(".back-link").click(function (e) {
        e.preventDefault()
        window.history.back();
    })

    //////////////////
    // Share button //
    //////////////////
    $('.single-ressources-analyses .external_link, .single-prospective .external_link').mouseover(function () {
        $("#share_on_social_network").show()
    }).mouseleave(function () {
        $("#share_on_social_network").hide()
    }).focusin(function () {
        $("#share_on_social_network").show()
    }).focusout(function () {
        // $("#share_on_social_network").hide()
    })
    $(document).focusout(function (e) {
        let clicked = $(e.target);
        let parent = clicked.parents(".print_share_button")
        if (!parent.length) $("#share_on_social_network").hide()
    })


    // $('.download_link').click(function (e) {
    //     e.preventDefault()
    //     bodyPDF()
    // })
}

// function bodyPDF() {
//     var doc = new jsPDF();
//
//     doc.html($("#content-page").get(0), {
//         callback: function (doc) {
//             doc.save();
//         },
//         x: 10,
//         y: 10
//     });
// }
//
//
// function s() {
//     let doc = new jsPDF();
//     let elementHandler = {
//         '#ignorePDF': function (element, renderer) {
//             return true;
//         }
//     };
//     let source = $("#content-page").get();
//     console.log(source)
//     doc.html(
//         source,
//         {
//             'width': 180,'elementHandlers': elementHandler
//         });
//
//     doc.output("dataurlnewwindow");
// }


//print
$('.print_link').click(function () {
    window.print();

});
